import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { produce } from "immer";
import { get, set } from "lodash";

import {
    syncDoorSubcomponentDirections,
    syncWallSubcomponentDirections,
} from "utils/enclosure/components";
import { BATCH_CHANGE, CHANGE } from "./root/types";

import user from "./users";
import organization from "./organizations";
import model from "features/Model/_ducks";
import enclosure from "features/Model/Enclosure/_ducks";
import drawingReducer from "features/Model/DrawingNew/_ducks/reducer";
import results from "features/Model/Review/Results/_ducks";
import upgrades from "features/Model/Upgrades/_ducks";
import create from "features/CreateModel/_ducks";
import upgradeLibrary from "./upgradeLibrary/reducers";
import chbaChecklist from "features/Model/ProjectPathChecklist/_ducks";
import imageGalleryReducer from "./imageGallery/reducers";
import community from "./community/reducers";
import commUpgrades from "features/Community/Upgrades/_ducks";
import parametricAnalysisReducer from "./parametricAnalysis/reducers";
import folderReducer from "./folders/reducer";
import paymentsReducer from "./payments/reducer";
import { default as newFormReducer } from "./form/reducer";

const appReducer = combineReducers({
    user,
    organization,
    model,
    enclosure,
    results,
    upgrades,
    create,
    upgradeLibrary,
    folder: folderReducer,
    drawing: drawingReducer,
    // form: formReducer,
    chbaChecklist,
    imageGallery: imageGalleryReducer,
    community,
    commUpgrades,
    parametricAnalysis: parametricAnalysisReducer,
    newForm: newFormReducer,
    payments: paymentsReducer,
});

const rootReducer = (state, action) => {
    if (action.type === CHANGE) {
        const isFacingDirectionChange = action.payload.path.endsWith(".facingDirection");
        const previousFacingDirection = isFacingDirectionChange
            ? get(state, action.payload.path)
            : undefined;

        return produce(state, (draft) => {
            set(draft, action.payload.path, action.payload.value);

            if (isFacingDirectionChange) {
                syncWallSubcomponentDirections(
                    draft,
                    action.payload.path,
                    action.payload.value,
                    previousFacingDirection
                );
                syncDoorSubcomponentDirections(
                    draft,
                    action.payload.path,
                    action.payload.value
                );
            }
        });
    }

    if (action.type === BATCH_CHANGE) {
        return produce(state, (draft) => {
            action.payload.changes.forEach(({ path, value }) => {
                set(draft, path, value);
            });
        });
    }

    return appReducer(state, action);
};

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false, immutableCheck: false, actionCreatorCheck: false }),
    devTools: import.meta.env.DEV,
});

export default store;
